import { render, staticRenderFns } from "./stuwork.vue?vue&type=template&id=7be83d19&scoped=true"
import script from "./stuwork.vue?vue&type=script&lang=js"
export * from "./stuwork.vue?vue&type=script&lang=js"
import style0 from "./stuwork.vue?vue&type=style&index=0&id=7be83d19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be83d19",
  null
  
)

export default component.exports